var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseenter":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_vm._t("default",null,{"hover":_vm.hover})],2)}
var staticRenderFns = []

export { render, staticRenderFns }